import { useState, useEffect, useRef, useCallback } from 'react';
import { fetchSensorData } from '../services/sensorService';

export const useSensorData = () => {
  const [sensorData, setSensorData] = useState([]);
  const [csvExportData, setCsvExportData] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [topic, setMachine] = useState('');
  const [loading, setLoading] = useState(false);
  const csvLinkRef = useRef();

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchSensorData(startDate, endDate, filterType, topic);
      setSensorData(data);
    } catch (err) {
      console.error("데이터 로드 실패:", err);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate, filterType, topic]);

  const exportFilteredData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchSensorData(startDate, endDate, filterType, topic);
      const mapped = data.map(({ payload, ...rest }) => ({
        ...rest,
        status: rest.ispass ? 'PASS' : 'FAIL',
      }));
      setCsvExportData(mapped);
    } catch (err) {
      console.error("CSV 내보내기 실패:", err);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate, filterType, topic]);

  useEffect(() => {
    if (csvExportData.length > 0 && csvLinkRef.current) {
      csvLinkRef.current.link.click();
    }
  }, [csvExportData]);

  return {
    sensorData,
    csvExportData,
    startDate,
    endDate,
    filterType,
    topic,
    loading,
    setStartDate,
    setEndDate,
    setFilterType,
    setMachine,
    loadData,
    exportFilteredData,
    csvLinkRef
  };
};